import { useState } from 'react'

const PRODUCTS_EDIT_MODAL_INITIAL_STATE = {
  loadingIframe: true,
  loadingSaveProducts: false,
  loadingSaveAndAddProducts: false,
  shouldShowAddProducts: false,
}

export const useProductsEditModal = () => {
  const [data, setData] = useState(PRODUCTS_EDIT_MODAL_INITIAL_STATE)

  const updateData = (newData: Record<string, boolean>) => {
    setData({
      ...data,
      ...newData,
    })
  }

  return {
    ...data,
    updateData,
  }
}
